let login = function(user, userContext, cartContext) {
  userContext.loginUser(user)
  cartContext.loginUser(user)
}

module.exports = {
  login: login
}
